import { createFileRoute } from '@tanstack/react-router'

import { StatsByDriversPage } from '@/pages/stats-by-drivers-page'

// TODO: решить вопрос с часовыми поясами

export const Route = createFileRoute('/_dashboard/_stats-layout/stats/by-drivers')({
    component: StatsByDriversPage,
})
